import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface ILounge {
  lounge: number;
  nameLounge: string;
}

export interface LoungesState {
  list: ILounge[];
  isLoaded: boolean;
}

const initialState: LoungesState = {
  list: [],
  isLoaded: false,
};

export const loungesSlice = createSlice({
  name: "lounges",
  initialState,
  reducers: {
    setLounges: (state, action: PayloadAction<ILounge[]>) => {
      state.list = action.payload;
      state.isLoaded = true;
    },
    clearLounges: (state) => {
      state.list = [];
      state.isLoaded = false;
    },
  },
});

export default loungesSlice.reducer;
export const { setLounges, clearLounges } = loungesSlice.actions;
